import React from 'react';
import SectionWithLeftIcon from 'components/organisms/section/sectionWithLeftIcon';
import graduateIcon from 'assets/icons/education/graduate.svg';
import highSchoolIcon from 'assets/icons/education/high-school.svg';
import Badge from 'components/atoms/badge';
import Heading from 'components/atoms/text/heading';
import locationIcon from 'assets/icons/education/location.svg';
import dateIcon from 'assets/icons/education/date.svg';
import creditHoursIcon from 'assets/icons/education/credit-hours.svg';
import softwareEngineeringIcon from 'assets/icons/education/software-engineering.svg';
import gpaIcon from 'assets/icons/education/gpa.svg';
import fourthIcon from 'assets/icons/education/fourth.svg';
import graduationProjectIcon from 'assets/icons/education/graduation-project.svg';
import hounorsDegreeIcon from 'assets/icons/education/honours-degree.svg';
import bachelorDegreeCertificate from 'assets/images/certifications/cu-certificate.jpg';
import highSchoolDiplomaCertificate from 'assets/images/certifications/mhs-certificate.jpg';

export default function Education() {
  return (
    <div className="flex flex-col gap-4">
      <SectionWithLeftIcon
        title={
          <Heading
            wrapText
            styles="w-full text-center md:text-start"
            text="Faculty of Computers and Artificial Intelligence"
          />
        }
        icon={graduateIcon}
        alt="Bachelor's degree"
        iconFooter="Bachelor's degree"
        iconLink={bachelorDegreeCertificate}>
        <div className="w-full pt-3">
          <div className="h-[110px] sm:h-auto overflow-y-auto flex flex-wrap gap-x-4 gap-y-2">
            <Badge text="Cairo University, Egypt" iconSrc={locationIcon} iconAlt="Graduation location" addIconPadding />
            <Badge text="August 2020" iconSrc={dateIcon} iconAlt="Graduation date" />
            <Badge
              text="Credit hours program"
              iconSrc={creditHoursIcon}
              iconAlt="Credit hours program"
              addIconPadding
            />
            <Badge
              text="Majored in software engineering"
              iconSrc={softwareEngineeringIcon}
              iconAlt="Software engineering"
              addIconPadding
            />
            <Badge text="GPA: 3.01 - Very good" iconSrc={gpaIcon} iconAlt="GPA" addIconPadding />
            <Badge text="Honours degree" iconSrc={hounorsDegreeIcon} iconAlt="Honours degree" />
            <Badge
              text="Graduation project's grade: Excellent"
              iconSrc={graduationProjectIcon}
              iconAlt="Graduation Project"
            />
            <Badge text="Ranked fourth among my department" iconSrc={fourthIcon} iconAlt="Ranked fourth" />
          </div>
        </div>
      </SectionWithLeftIcon>
      <SectionWithLeftIcon
        title={<Heading wrapText styles="w-full text-center md:text-start" text="New Manor House School" />}
        icon={highSchoolIcon}
        alt="High School Diploma"
        iconFooter="High School Diploma"
        iconLink={highSchoolDiplomaCertificate}>
        <div className="w-full pt-3">
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            <Badge
              text="El Sheikh Zayed, Egypt"
              iconSrc={locationIcon}
              iconAlt="High school diploma location"
              addIconPadding
            />
            <Badge text="July 2016" iconSrc={dateIcon} iconAlt="High school diploma date" />
          </div>
        </div>
      </SectionWithLeftIcon>
    </div>
  );
}
